import { MoneyV2, CurrencyCode } from "./shopify/sdk";
export const shopifyToIntlPrice = (moneyV2: MoneyV2) =>
  Intl.NumberFormat("en-GB", {
    currency: moneyV2?.currencyCode || CurrencyCode.Eur,
    currencyDisplay: "symbol",
    style: "currency",
  }).format(moneyV2?.amount || 0);
